<template>
  <div class="cp-home-wrapper">
    <div class="cp-section">
      <OrderList :limit="1" :show-header="false" title="Recent Order" :is_active="false" :checkout="false" />
    </div>
    <div v-if="popularProducts.length" class="cp-section">
      <div class="cp-subheading d-flex align-items-center justify-content-between">
        <span class="flex-grow-1">Popular Products</span>
        <span v-if="hasMoreProduct" class="cp-showmore" @click.stop="toggleShowMore()">{{ showMore ? 'Show Less' : 'Show More' }}</span>
      </div>
      <div class="pp-wrapper">
        <b-card v-for="(product, index) in popularProducts" class="pp__item" v-bind:key="'pp-'+index" :class="{'show-all': showMore}">
          <div class="pp__item__image">
            <img :src="getImageUrl(product)" @error="setAltImg" :alt="product.name" />
          </div>
          <p class="pp__item__name">{{product.name}}</p>
          <p class="pp__item__price">{{product.price | currency}}</p>
          <div class="d-flex flex-column flex-md-row pp__item__btns">
            <b-button @click.stop="addToCart(product, true)" variant="primary" class="pp__item__add mb-2 mb-md-0 mr-0 mr-md-2 cp-buy-now">
              Buy Now
            </b-button>
            <b-button @click.stop="addToCart(product)" class="pp__item__add btn-outline-success">
              <font-awesome-icon class="d-none d-md-block mr-2 mr-md-0" :icon="['fas', 'shopping-cart']" />
              <span class="d-md-none">Add to Cart</span>
            </b-button>
          </div>
        </b-card>

        <OrderCheckout
          v-if="showCheckout"
          :items="selectedItems"
          :is-subscription="false"
          :skip-initial="true"
          @clear="toggleCheckout()">
        </OrderCheckout>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {getCampaignProductImageUrl, getPlaceholderImageUrl, prepareCartItems} from '@/utils'
import {mapGetters, mapState} from 'vuex'

const OrderList = () => import('./../Order/OrderList')
const OrderCheckout = () => import('./../Order/OrderCheckout')

export default {
  name: 'CustomerPortalHome',
  components: {OrderList, OrderCheckout},
  computed: {
    ...mapState(['session', 'cart']),
    ...mapGetters(['checkoutDisabled'])
  },
  data: function() {
    return {
      recentOrders: [],
      popularProducts: [],
      showCheckout: false,
      selectedItems: [],
      showMore: false,
      hasMoreProduct: false
    }
  },
  methods: {
    toggleCheckout: function(items) {
      this.showCheckout = !this.showCheckout
      this.selectedItems = items || []
    },
    getImageUrl: function(product) {
      return getCampaignProductImageUrl(product, 'original')
    },
    setAltImg: function() {
      event.target.src = getPlaceholderImageUrl('small')
    },
    postAddToCartProcess: function(checkout) {
      if (checkout) {
        this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
      } else {
        this.$store.commit('set_cart_state', true)
        setTimeout(() => {
          this.$store.commit('set_cart_state', false)
          this.$store.commit('ready')
        }, 5000)
      }
    },
    addToCart: function(products, checkout) {
      const cart = this.cart || []
      if (!(products instanceof Array)) {
        products = [products]
      }
      const items = prepareCartItems(cart, {products, checkout})
      if (items.length > 0) {
        this.$store.commit('busy')
        this.$store.dispatch('add_cart', items)
          .then(() => {
            this.postAddToCartProcess(checkout)
            this.$store.commit('ready')
          })
          .catch(err => {
            let errorMessage = ''
            if (err.response.status === 400) {
              errorMessage = err.response.data['items']
            }
            this.$store.commit('error', errorMessage || err)
            this.$store.commit('ready')
          })
      } else {
        this.postAddToCartProcess(checkout)
      }
    },
    toggleShowMore: function() {
      this.showMore = !this.showMore
    },
    showMoreProducts: function() {
      if (window) {
        if (window.innerWidth < 992) {
          this.hasMoreProduct = this.popularProducts.length > 2
        } else {
          this.hasMoreProduct = this.popularProducts.length > 3
        }
      }
    }
  },
  created() {
    axios.get('/campaign_products/popular/')
      .then((result) => {
        this.popularProducts = result.data || []
        this.showMoreProducts()
      })
      .catch((error) => this.$store.commit('critical_error', error))

    window.addEventListener('resize', this.showMoreProducts)
  }
}
</script>

<style scoped>

</style>
